module.exports = __webpack_public_path__ + "static/grafika12-8ddfd029e4dd4272034bf0d8c04effc7.png";